import { ValueWithRandom } from "../../../ValueWithRandom";
export class PathDelay extends ValueWithRandom {
  constructor() {
    super();
  }
}